import { throttle } from 'lodash';
import { useRef } from 'react';
import { isTouchDevice } from "../utils";

export const useDragScrolling = () => {
  const isScrolling = useRef(false);

  const goDown = () => {
    document.documentElement.scrollTop += 9;

    if (isScrolling.current) {
      window.requestAnimationFrame(goDown);
    }
  };

  const goUp = () => {
    document.documentElement.scrollTop -= 9;
    if (isScrolling.current && window.scrollY > 0) {
      window.requestAnimationFrame(goUp);
    }
  };

  const onDragOver = (event) => {
    const y = isTouchDevice() ? event.touches[0].clientY : event.clientY;

    const isMouseOnTop = y < 150;
    const isMouseOnDown = window.innerHeight - y < 150;

    if (!isScrolling.current && (isMouseOnTop || isMouseOnDown)) {
      isScrolling.current = true;

      if (isMouseOnTop) {
        window.requestAnimationFrame(goUp);
      }

      if (isMouseOnDown) {
        window.requestAnimationFrame(goDown);
      }
    } else if (!isMouseOnTop && !isMouseOnDown) {
      isScrolling.current = false;
    }
  };

  const throttleOnDragOver = throttle(onDragOver, 100);

  const addEventListenerForWindow = () => {
    window.document.body.addEventListener('touchmove', throttleOnDragOver);
    window.addEventListener('dragover', throttleOnDragOver);
  };

  const removeEventListenerForWindow = () => {
    window.document.body.removeEventListener('touchmove', throttleOnDragOver);
    window.removeEventListener('dragover', throttleOnDragOver);
    isScrolling.current = false;
  };

  return {
    addEventListenerForWindow,
    removeEventListenerForWindow
  };
};
